import {useRef, useState} from "react";
import { lang } from "../utils/getLanguage";
import {languages} from "../utils/languages";

const SocketChatStates = () => {
    const socketRef = useRef(null);
    const [langIndex, setLangIndex] = useState(() => {
        const stored = localStorage.getItem("langIndexForChatRoom");
        const fromStorage = stored !== null ? Number(stored) : null;

        const langCode = lang();
        const fromLang = languages.indexOf(langCode);

        return fromStorage ?? (fromLang !== -1 ? fromLang : 0);
    });
    const [rooms, setRooms] = useState(null);
    const [onlineCount, setOnlineCount] = useState(0);
    const [gameOnlineData, setGameOnlineData] = useState(null);
    console.log(langIndex, localStorage.getItem("langIndexForChatRoom"), languages.indexOf(lang()))

    return {
        langIndex, setLangIndex,
        rooms, setRooms,
        onlineCount, setOnlineCount,
        gameOnlineData, setGameOnlineData,
        socketRef
    };
}

export default SocketChatStates;